import { Plugin, ButtonView, icons } from 'ckeditor5';
import image from '../../../../static/img/icons/paste_text.svg'

export default class Preview extends Plugin {
    init() {
        console.log('this is icons',image)
        icons.Preview
        const editor = this.editor;

        editor.ui.componentFactory.add( 'preview', locale => {
            const view = new ButtonView( locale );

            view.set( {
                label: 'Preview',
                withText: false, // Display only the icon, no text
                tooltip: true,
                icon: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.25 2C5.0095 2 4 3.0095 4 4.25V19.75C4 20.9905 5.0095 22 6.25 22H12.8164C12.3889 21.5555 12.0253 21.0515 11.7373 20.5H6.25C5.8365 20.5 5.5 20.1635 5.5 19.75V4.25C5.5 3.8365 5.8365 3.5 6.25 3.5H12V7.75C12 8.9905 13.0095 10 14.25 10H18.5V11.085C19.0225 11.166 19.5265 11.3015 20 11.499V9.24902C20 9.04202 19.916 8.85548 19.7803 8.71973L13.2803 2.21973C13.1446 2.08404 12.9572 2 12.75 2H6.25ZM13.5 4.56055L17.4385 8.49902H14.25C13.8365 8.49902 13.5 8.16252 13.5 7.74902V4.56055ZM17.5 12C14.4625 12 12 14.4625 12 17.5C12 20.5375 14.4625 23 17.5 23C20.5375 23 23 20.5375 23 17.5C23 14.4625 20.5375 12 17.5 12ZM17.5 15C20.091 15 21.3781 17.1565 21.4316 17.248C21.5221 17.404 21.5221 17.596 21.4316 17.752C21.3781 17.844 20.091 20 17.5 20C14.909 20 13.6219 17.8435 13.5684 17.752C13.4779 17.596 13.4779 17.404 13.5684 17.248C13.6219 17.1565 14.909 15 17.5 15ZM17.5 16C16.6715 16 16 16.6715 16 17.5C16 18.3285 16.6715 19 17.5 19C18.3285 19 19 18.3285 19 17.5C19 16.6715 18.3285 16 17.5 16Z" fill="black"/>
</svg>

`
            } );

            // view.extendTemplate({
            //     attributes: {
            //         class: ['bi', 'bi-printer'] // FontAwesome classes for the "eye" icon
            //     }
            // });

            // Define what happens when the button is clicked.
            view.on( 'execute', () => {
                const data = editor.getData();
                console.log('this is data', data)
                
                // Open the preview in a new tab in the same browser window
                const previewWindow = window.open('', '_blank');

                // Ensure the new tab gets focus
                previewWindow.focus();

                // Write the editor content into the new tab
                previewWindow.document.write(`
                    <html>
                        <head>
                            <title>Preview</title>
                        </head>
                        <body>${data}</body>
                    </html>
                `);

                // Close the document to ensure rendering is complete
                previewWindow.document.close();
            } );

            return view;
        } );
    }
}
